import { ref } from 'vue';

const toasts = ref([]);
const DEFAULT_DURATION_MS = 4000;

/**
 * Show a toast message.
 * @param {string} message - Text to display
 * @param {'success'|'error'|'info'} type - Toast type (affects styling)
 * @param {number} durationMs - Auto-dismiss after ms (0 = no auto-dismiss)
 */
export function useToast() {
  function show(message, type = 'info', durationMs = DEFAULT_DURATION_MS) {
    const id = Math.random().toString(36).slice(2);
    toasts.value = [...toasts.value, { id, message, type }];
    if (durationMs > 0) {
      setTimeout(() => dismiss(id), durationMs);
    }
    return id;
  }

  function dismiss(id) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return { toasts, show, dismiss };
}
